/**
 * Translation Hook
 *
 * React hook for using translations in components.
 */

import { useCallback } from 'react'
import { t as translate, getLanguage, Language } from '@/i18n'

interface UseTranslationResult {
  t: (key: string, params?: Record<string, string | number>) => string
  language: Language
}

/**
 * Hook for using translations in React components
 *
 * @example
 * function MyComponent() {
 *   const { t } = useTranslation()
 *   return <h1>{t('articles.title')}</h1>
 * }
 */
export function useTranslation(): UseTranslationResult {
  const language = getLanguage()

  const t = useCallback(
    (key: string, params?: Record<string, string | number>) => {
      return translate(key, params)
    },
    []
  )

  return { t, language }
}
